import { Card } from "react-bootstrap";
import ClipboardCopy from "components/Clipboard/ClipboardCopy";

const CopyCard = ({ value, children, className, ...props }) => {
  if (!children) {
    children = value;
  }
  const classList = ["d-inline-block py-1 ps-2 pe-4"];
  if (className) {
    classList.push(className);
  }
  return <Card className={classList.join(" ")} {...props}>
    <Card.Body className="p-0">
      <span className="text-break text-wrap me-2">{children}</span>
      <ClipboardCopy value={value} className="position-absolute end-0 me-1"></ClipboardCopy>
    </Card.Body>
  </Card>;
};
export default CopyCard;